import { createFileRoute } from '@tanstack/react-router';
import { getPageWithContent } from '@/services/docs';
import DocsGroupPage, { DocsGroupPageLoading } from '@/components/Docs/DocsGroupPage';

export const Route = createFileRoute('/docs/$section/$slug')({
  loader: async ({ params }) =>
    getPageWithContent(params.section, params.slug, 'documentation'),
  pendingComponent: DocsGroupPageLoading,
  component: DocsPage,
});

function DocsPage() {
  const page = Route.useLoaderData();
  return <DocsGroupPage page={page} />;
}
